<div class="modal-header">
    <h4 class="modal-title">Çalışan Güncelle</h4>
</div>
<div class="modal-body col-12">
    <form [formGroup]="personForm">
        <ul ngbNav #nav="ngbNav" class="nav-tabs">
            <li ngbNavItem>
                <a ngbNavLink>Personel Bilgileri</a>
                <ng-template ngbNavContent>
                    <div class="row">
                        <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                            <label for="title">İsim</label>
                            <div class="form-group">
                                <div class="input-group">
                                    <input type="text" class="form-control" id="name" formControlName="name"
                                        maxlength="30" />
                                </div>
                                <div *ngIf="personForm.get('name').invalid && personForm.get('name').touched"
                                    class="text-danger">
                                    İsim zorunludur.
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                            <label for="description">Soyisim</label>
                            <div class="form-group">
                                <div class="input-group">
                                    <input type="text" class="form-control" id="lastName" formControlName="lastName"
                                        maxlength="50" />
                                </div>
                                <div *ngIf="personForm.get('lastName').invalid && personForm.get('lastName').touched"
                                    class="text-danger">
                                    Soyisim zorunludur.
                                </div>
                            </div>
                        </div>

                        <!-- <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                            <label for="department">Departman</label>
                            <div class="form-group">
                                <input type="text" class="form-control" id="department" formControlName="department"
                                    maxlength="50" />
                            </div>
                        </div>

                        <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                            <label for="description">Görev</label>
                            <div class="form-group">
                                <div class="input-group">
                                    <input type="text" class="form-control" id="mission" formControlName="mission"
                                        maxlength="50" />
                                </div>
                                <div *ngIf="personForm.get('mission').invalid && personForm.get('mission').touched"
                                    class="text-danger">
                                    Görev zorunludur.
                                </div>
                            </div>
                        </div> -->

                        <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                            <label for="description">Departman</label>
                            <div class="form-group">
                                <ng-select [items]="depertmants" bindLabel="name" bindValue="id"
                                    placeholder="Departman seçin" formControlName="depertmantId">
                                    <ng-template ng-header-tmp>
                                        <button
                                            class="add-new-customer btn btn-flat-success cursor-pointer rounded-0 text-left p-50 w-100"
                                            (click)="showCreateDepartmanDialog(); select.blur(); select.close()">
                                            <i data-feather="plus"></i>
                                            <span class="align-middle ml-25">Yeni Departman Ekle</span>
                                        </button>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                            <label for="description">Görev</label>
                            <div class="form-group">
                                <ng-select [items]="missions" formControlName="missionId" bindLabel="name"
                                    bindValue="id" placeholder="Görev seçin">
                                    <ng-template ng-header-tmp>
                                        <button
                                            class="add-new-customer btn btn-flat-success cursor-pointer rounded-0 text-left p-50 w-100"
                                            (click)="showCreateMissionDialog(); select.blur(); select.close()">
                                            <i data-feather="plus"></i>
                                            <span class="align-middle ml-25">Yeni Görev Ekle</span>
                                        </button>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                            <label for="description">Tel No</label>
                            <div class="form-group">
                                <div class="input-group">
                                    <input type="text" class="form-control" id="phoneNumber"
                                        formControlName="phoneNumber" mask="(000) 000 00 00" />
                                </div>

                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                            <label for="tc">T.C. Kimlik No</label>
                            <div class="form-group">
                                <input type="text" class="form-control" id="tc" formControlName="tc" maxlength="11" />
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                            <label for="wage">Maaş</label>
                            <div class="form-group">
                                <input type="number" class="form-control" id="wage" formControlName="wage" />
                            </div>
                        </div>

                        <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                            <label for="startDate">İşe Başlama Tarihi</label>
                            <div class="form-group">
                                <ng2-flatpickr [config]="dateTimeEndOptions" name="dateTime" formControlName="startDate"
                                    [setDate]="startDate ?? date"></ng2-flatpickr>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                            <label for="description">Email</label>
                            <div class="form-group">
                                <div class="input-group">
                                    <input type="email" class="form-control" id="mail" formControlName="mail" />
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                            <label for="registrationNumber">Sicil No</label>
                            <div class="form-group">
                                <div class="input-group">
                                    <input type="text" class="form-control" id="registrationNumber"
                                        formControlName="registrationNumber" />
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                            <label for="birthDay">Doğum Tarihi</label>
                            <div class="form-group">
                                <ng2-flatpickr [config]="dateTimeStartOptions" name="dateTime"
                                    formControlName="birthDay" [setDate]="birthDate ?? date"></ng2-flatpickr>
                            </div>
                        </div>

                        <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                            <label for="workingStatus">Çalışma Durumu</label>
                            <div class="form-group d-flex align-items-center gap-1">
                                <input type="checkbox" id="workingStatus" formControlName="workingStatus" />
                                <span>
                                    {{ personForm.get('workingStatus')?.value ? 'Aktif' : 'Pasif' }}
                                </span>
                            </div>
                        </div>

                        <div class="col-xl-3 col-md-6 col-sm-12 col-12" *ngIf="!personForm.value.workingStatus">
                            <label for="leaveJob">İşten Ayrılma Tarihi</label>
                            <div class="form-group">
                                <ng2-flatpickr [config]="dateTimeEndOptions" name="dateTime" formControlName="leaveJob"
                                    [setDate]="leaveDate"></ng2-flatpickr>
                                <div *ngIf="personForm.get('leaveJob')?.invalid && (personForm.get('leaveJob')?.touched || submitted)"
                                    class="text-danger">
                                    Ayrılma Tarihi zorunludur.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-6 col-md-6 col-sm-12 col-12">
                            <label for="emergencyContact">Açıklama</label>
                            <div class="form-group">
                                <textarea class="form-control" id="emergencyContact" formControlName="emergencyContact"
                                    maxlength="1000"></textarea>
                            </div>
                        </div>
                        <div class="col-xl-6 col-md-6 col-sm-12 col-12">
                            <label for="description">Adres</label>
                            <div class="form-group">
                                <div class="input-group">
                                    <textarea class="form-control" id="address" formControlName="address"
                                        maxlength="200"></textarea>
                                </div>
                            </div>
                        </div>

                    </div>
                </ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink>Mesai Bilgileri</a>
                <ng-template ngbNavContent>
                    <div class="row">
                        <div class="col-12">
                            <label for="workingDays">Çalışma Günleri ve Saatleri</label>
                            <form #timeForm="ngForm">
                                <div class="row" *ngFor="let day of days;let i = index"
                                    class="mb-1 d-flex align-items-center">
                                    <!-- Checkbox ve gün etiketi -->
                                    <div class="custom-control custom-checkbox col-md-2">
                                        <input type="checkbox" class="custom-control-input" [id]="day.name"
                                            [(ngModel)]="day.selected" name="{{ day.name }}Checked" />
                                        <label class="custom-control-label" [for]="day.name">{{ day.label }}</label>
                                    </div>

                                    <!-- Başlangıç saati -->
                                    <div *ngIf="day.selected" class="col-md-4 d-flex align-items-center">
                                        <label class="mr-2">Başlangıç</label>
                                        <ngb-timepicker [(ngModel)]="day.startTime" name="{{ day.name }}StartTime"
                                            [spinners]="false" class="timepicker"></ngb-timepicker>
                                    </div>

                                    <!-- Bitiş saati -->
                                    <div *ngIf="day.selected" class="col-md-4 d-flex align-items-center">
                                        <label class="mr-2">Bitiş</label>
                                        <ngb-timepicker [(ngModel)]="day.endTime" name="{{ day.name }}EndTime"
                                            [spinners]="false" class="timepicker"></ngb-timepicker>
                                    </div>

                                    <div *ngIf="i === 0 && day.selected" class="col-md-2">
                                        <button type="button" class="btn btn-sm btn-primary"
                                            (click)="applyToAll()">Tümüne Uygula</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li ngbNavItem *ngIf="authService.isEndpointStatus('PUT.Updateing.UpdatePersonProjects')">
                <a ngbNavLink>Proje Seç</a>
                <ng-template ngbNavContent>
                    <label class="form-label fw-bold">Proje Seç</label>
                    <ng-select [items]="projects" bindLabel="name" [multiple]="true" formControlName="projects"
                        [closeOnSelect]="false" placeholder="Projeleri seçin" (change)="onProjectChange($event)">
                        <ng-template ng-label-tmp let-item="item" let-clear="clear">
                            <span class="ng-value-label">{{ item.name }}</span>
                            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                        </ng-template>
                    </ng-select>

                    <div *ngIf="selectedProjects.length > 0" class="mt-3">
                        <label class="fw-bold d-block mb-2">Görünürlük Ayarları</label>
                        <div *ngFor="let p of selectedProjects" class="form-check form-switch">
                            <input type="checkbox" class="form-check-input" [checked]="p.isVisible"
                                (change)="toggleProjectVisibility(p, $event.target.checked)">
                            <label class="form-check-label">{{ p.name }} görünür mü?</label>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li ngbNavItem="yetki" *ngIf="authService.isEndpointStatus('GET.Reading.GetByIdPersonRoles')">
                <a ngbNavLink>Yetki</a>
                <ng-template ngbNavContent>
                    <div *ngFor="let role of roles" class="col-12">
                        <input type="checkbox" class="form-check-input" (change)="onRoleChange(role.id, $event)"
                            [checked]="selectedRoles?.includes(role.id)" />
                        <label class="form-check-label">{{ role.roleName }}</label>
                    </div>
                    <button type="button" class="btn btn-success" (click)="createGlobalPeronRoles(selectedRoles)"
                        [disabled]="selectedRoles?.length < 1"
                        *ngIf="authService.isEndpointStatus('POST.Writing.AssignmentPersonRoles')">Yetkileri
                        Kaydet</button>
                    <button type="button" class="btn btn-danger" (click)="removeAllRoles()"
                        [disabled]="selectedRoles?.length < 1"
                        *ngIf="authService.isEndpointStatus('POST.Writing.AssignmentPersonRoles')">
                        Tüm Yetkileri Kaldır
                    </button>
                </ng-template>
            </li>


        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
    <button type="button" class="btn btn-success" [disabled]="!personForm.valid" (click)="onSumbit()"
        *ngIf="nav.activeId !== 'yetki'">Kaydet</button>
</div>